import { useCreateCompany } from "@/api/console/companies/useCreateCompany";
import BottomBar from "@/components/BottomBar";
import { Button } from "@/components/ui/button";
import { handleFormErrors } from "@/lib/handleFormErrors";
import toast from "@/lib/toast";
import { CompanyCreate } from "@/schema/console/companies/CompanyCreate";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { mutate } from "swr";

const CompanyFormActionButtons = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSubmit, setError } = useFormContext<CompanyCreate>();

  const { trigger: createCompany, isMutating: isCompanyMutating } =
    useCreateCompany({
      onSuccess: (data) => {
        toast.success(data.message);
        mutate("/console/companies");
        navigate("/console/companies");
      },
      onError: (error) => {
        handleFormErrors(error.errors, setError);
      },
    });

  const handleAdd = (data: CompanyCreate) => {
    toast.loading(t("add-company-loading"));
    createCompany(data);
  };

  return (
    <BottomBar backLink="/console/companies">
      <Button isLoading={isCompanyMutating} onClick={handleSubmit(handleAdd)}>
        {t("add-company")}
      </Button>
    </BottomBar>
  );
};

export default CompanyFormActionButtons;
